import client from "./client";

export const fetchBuddies = () => client.get("/buddies").then((r) => r.data);

export const removeBuddy = (buddyUserId) => client.delete(`/buddies/${buddyUserId}`).then((r) => r.data);
